import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(
  ({ zIndex, transitions, spacing }) => ({
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: zIndex.snackbar - 1,
      opacity: 0,
      visibility: 'hidden',
      transition: transitions.create(['opacity', 'visibility'], {
        duration: transitions.duration.standard,
        easing: transitions.easing.easeOut,
      }),

      '&.is-visible': {
        opacity: 1,
        visibility: 'visible',
      },
    },
    bottomPositioned: {
      bottom: spacing(6.5),
    },
  }),
  { name: 'GenMessage' },
);

export default styles;
